const jwt_customizer = {
    general: "Une erreur s'est produite lors de la personnalisation du jeton JWT. Veuillez réessayer ultérieurement.",
    can_not_create_for_admin_tenant: 'Impossible de créer un personnaliseur de jeton JWT pour le locataire administratif.',
};
export default Object.freeze(jwt_customizer);
